import {
  Autocomplete,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import notify from "../../../Notifcation";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllTouristTypeAction,
  createTouristTypeAction,
  deleteTouristTypeAction,
  updateTouristTypeAction,
} from "../../../redux/actions/TouristAction";
import { countries } from "../../COUNTRIES.";
const TouristRsdenceAdmin = ({ keyy }) => {
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const [Location, setLocation] = useState("");
  const [TouristTypeId, setTouristTypeId] = useState("");
  const [ISedit, setISedit] = useState(false);
  const [Category, setCategory] = useState("");
  const [Deletesow, setDeletesow] = useState(false);
  const handleCloseDelete = () => setDeletesow(false);
  const handleShowDelete = (item) => {
    setDeletesow(true);
    setTouristTypeId(item.id);
  };
  const All = useSelector((state) => state.TouristReduser.GetallTouristType);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetAllTouristTypeAction(`type=${keyy}`));
  }, [keyy]);
  const handlesubmit = async (e) => {
    e.preventDefault();

    if (Location === "" || Category === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    await dispatch(
      createTouristTypeAction({
        location: Location.name,
        type: "residence",
        category: Category,
      })
    );
    setLocation("");
    setCategory("");
    setLoading(false);
    setisPress(false);
  };
  const handlesubmitUpdate = async (e) => {
    e.preventDefault();
    if (Category === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    await dispatch(
      updateTouristTypeAction({
        category: Category,
        tourist_application_type_id: TouristTypeId,
      })
    );
    setLoading(false);
    setisPress(false);
    setISedit(false);
    setLocation("");
    setTouristTypeId("");
    setCategory("");
  };
  const update = (item) => {
    setISedit(true);
    setCategory(item.category);
    setLocation(item.location);
    setTouristTypeId(item.id);
  };
  const res = useSelector((state) => state.TouristReduser.createTouristType);
  const Update = useSelector((state) => state.TouristReduser.UpdateTouristType);
  const Del = useSelector((state) => state.TouristReduser.deleteTouristType);
  const handleDelete = async () => {
    setisPress(true);
    await dispatch(
      deleteTouristTypeAction({
        tourist_application_type_id: TouristTypeId,
      })
    );
    setDeletesow(false);
    setLoading(false);
    setisPress(false);
    setTouristTypeId("");
  };
  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            dispatch(GetAllTouristTypeAction(`type=residence`));
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
            dispatch(GetAllTouristTypeAction(`type=residence`));
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
            dispatch(GetAllTouristTypeAction(`type=residence`));
          }
        }
      }

      if (Update) {
        if (Update.status === 200 || Update.status === 201) {
          if (Update.data) {
            notify(Update.data.message, "success");
            dispatch(GetAllTouristTypeAction());
          }
        } else if (Update.status !== 200 || Update.status !== 201) {
          if (Update.data) {
            notify(Update.data.message, "error");
            dispatch(GetAllTouristTypeAction(`type=residence`));
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
            dispatch(GetAllTouristTypeAction(`type=residence`));
          }
        }
      }

      if (Del) {
        if (Del.status === 200 || Del.status === 201) {
          if (Del.data) {
            notify(Del.data.message, "success");
            dispatch(GetAllTouristTypeAction());
          }
        } else if (Del.status !== 200 || Del.satus !== 201) {
          if (Del.data) {
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
            dispatch(GetAllTouristTypeAction(`type=residence`));
          }
        }
      }
    }
  }, [loading]);
  return (
    <>
      <Container>
        <div className="inputs-container">
          <div className="inp-container ">
          <Autocomplete
              disabled={ISedit}
              disablePortal
              id="combo-box-demo"
              value={Location}
              options={countries && countries.length >= 0 ? countries : []}
              sx={{ width: 300 }}
              onChange={(e, v) => setLocation(v)}
              getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === "string") {
                  return option;
                }
                // Add "xxx" option created dynamically
                if (option.inputValue) {
                  return option.inputValue;
                }
                // Regular option
                return option.name;
              }}
              // renderOption={(props, option) => (
              //   <li {...props} key={option.id}>
              //     {option.name}
              //   </li>
              // )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    <Typography>
                      الدولة
                      <span style={{ color: "red", fontSize: "21px" }}>*</span>
                    </Typography>
                  }
                />
              )}
            />
          </div>
          <div className="inp-container ">
            <TextField
              label={
                <Typography>
                  المدة
                  <span style={{ color: "red", fontSize: "21px" }}>*</span>
                </Typography>
              }
              type="text"
              value={Category}
              onChange={(e) => setCategory(e.target.value)}
              variant="outlined"
            />
          </div>
          <div className="inp-container "></div>

          <div className="inp-container "></div>
        </div>
        {loading && isPress ? (
          <button className="buttonadd">
            <Spinner />
          </button>
        ) : ISedit ? (
          <button className="buttonadd" onClick={handlesubmitUpdate}>
            تعديل
          </button>
        ) : (
          <button className="buttonadd" onClick={handlesubmit}>
            إضافة
          </button>
        )}
        <hr />
        <Table className="maint" responsive striped bordered hover>
          <thead>
            <tr>
              <th>
                النوع <i className="fa-solid fa-user"></i>
              </th>
              <th>
                الدولة <i className="fa-solid fa-address-card"></i>
              </th>
              <th>
                المدة <i className="fa-solid fa-address-card"></i>
              </th>

              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {All && All.length >= 0
              ? All.map((item, idx) => (
                  <tr key={idx}>
                    <td>
                      {item.type === "visa"
                        ? "فيزا"
                        : item.type === "residence"
                        ? "أقامة"
                        : null}
                    </td>
                    <td>{item.location}</td>
                    <td>{item.category}</td>
                    <td className="icon-w">
                      <i
                        onClick={() => update(item)}
                        className="fa fa-solid fa-pen-to-square"
                        style={{ color: "rgb(0 44 146)" }}
                      ></i>
                    </td>
                    <td className="icon-w">
                      {" "}
                      <i
                        onClick={() => handleShowDelete(item)}
                        className="fs fa-solid fa-trash-can"
                        style={{ color: "red" }}
                      ></i>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </Table>
        <ToastContainer />
      </Container>
      <Modal
        show={Deletesow}
        onHide={handleCloseDelete}
        backdrop="static"
        centered
        keyboard={false}
        contentClassName="cont"
        style={{ width: "100%", margin: "0px auto", textAlign: "center" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>هل تريد حذف العنصر</Modal.Title>
        </Modal.Header>
        {/* <Modal.Body>
          {" "}
          <Addcategory />{" "}
        </Modal.Body> */}

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseDelete}
          >
            إغلاق
          </Button>
          <Button variant="secondary" className="close" onClick={handleDelete}>
            موافق
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TouristRsdenceAdmin;
